import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import Vuex from 'vuex';
import $ from 'jquery';

import VueLazyLoad from 'vue-lazyload';
import LightBox from 'vue-image-lightbox';


import VueMask from 'v-mask';
Vue.use(VueMask);

import { store } from "./store/index.js";

// Plugins
import App from "./App.vue";

// router setup
import routes from "./routes/routes";

import './registerServiceWorker'


require('./library/obj_user.js');
require('./library/filters.js');
require("./assets/css/table.css");
require("./assets/css/extra.css");

//console.log(process.env);

window.URL_API = process.env.VUE_APP_URL_API; // "http://localhost:8086/api/";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueLazyLoad);
Vue.use(LightBox);

//


console.log(routes);
const router = new VueRouter({
        routes: routes,
        linkExactActiveClass: "nav-item active"
});


//console.log(process.env);

/* eslint-disable no-new */
new Vue({
        el: "#app",
        store,
        render: h => h(App),
        router,
        // data: {
        //   Chartist: Chartist
        // }
});

$(document).load(function () {
        $(document.body).removeClass("perfect-scrollbar-on"); //perfect scrollbar deu problema em produção.
        //console.log(document.body.className);
        //console.log("tentei retirar scrollbar");
});
